<template>
  <register-form v-if="pageType === 'OEGG'" />
  <rockbowl-form v-else-if="currentPageType === 'register-rockbowl'" />
  <visa-form v-else-if="currentPageType === 'icsmge-visum-application'" />
</template>

<script>
import { pageTypeResource } from "./../api/resources";
import RockbowlForm from "./RockbowlForm";
import RegisterForm from "./RegisterForm";
import VisaForm from "./VisaForm.vue";

export default {
  components: {
    RockbowlForm,
    RegisterForm,
    VisaForm,
  },
  data: () => ({
    pageType: null,
    currentPageType: "",
  }),
  async created() {
    this.currentPageType = window.pageType || "icsmge-visum-application";
    this.pageType = (await pageTypeResource.get()).data.type;
  },
};
</script>
